import { __awaiter, __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { ToastController, IonicModule } from '@ionic/angular';
import { ClipboardService, ClipboardModule } from 'ngx-clipboard';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';

let UiCBilletReviewComponent = class UiCBilletReviewComponent {
    constructor(toastCtrl, clipboardService) {
        this.toastCtrl = toastCtrl;
        this.clipboardService = clipboardService;
        this.shareBilletOnPage = new EventEmitter();
        this.printBilletOnPage = new EventEmitter();
        this.dismiss = new EventEmitter();
    }
    copyBilletCode() {
        this.clipboardService.copyFromContent(this.billetCode);
        this.toastCopy();
    }
    shareBillet() {
        this.shareBilletOnPage.emit();
    }
    printBillet() {
        this.printBilletOnPage.emit();
    }
    dismissEvent() {
        this.dismiss.emit();
    }
    toastCopy() {
        return __awaiter(this, void 0, void 0, function* () {
            const toast = yield this.toastCtrl.create({
                message: 'Dados copiados!',
                duration: 2000
            });
            toast.present();
        });
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCBilletReviewComponent.prototype, "rechargeValue", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCBilletReviewComponent.prototype, "billetCode", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCBilletReviewComponent.prototype, "hasCancelButton", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCBilletReviewComponent.prototype, "hasShareButton", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCBilletReviewComponent.prototype, "hasPrintButton", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCBilletReviewComponent.prototype, "shareBilletOnPage", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCBilletReviewComponent.prototype, "printBilletOnPage", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCBilletReviewComponent.prototype, "dismiss", void 0);
UiCBilletReviewComponent = __decorate([
    Component({
        selector: 'ui-c-billet-review',
        template: "<div class=\"billet-review\">\n  <div class=\"recharge-col mt-5 d-flex flex-column align-items-center justify-content-around\">\n    <div class=\" ion-text-center\">\n      <h2 class=\"font-weight-bold\">{{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.DESCRIPTION.PRIMARY' | wlpTranslate}}</h2>\n    </div>\n    <p class=\"d-flex align-items-end\">\n      <span class=\"align-self-start\">R$</span>\n      <span class=\"recharge-money\">{{rechargeValue}}</span>\n    </p>\n    <div class=\"d-flex align-items-center\">\n      <ion-button fill=\"clear\" color=\"dark\" id=\"copyBtn\" (click)=\"copyBilletCode()\" data-clipboard-target=\"#copyTarget\">\n        <div class=\"d-flex flex-column\">\n          <div>\n            <ion-icon class=\"icon-size\" [name]=\"'copy-outline'\"></ion-icon>\n          </div>\n          <div>\n            <span class=\"text-capitalize\">{{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.COPY' | wlpTranslate}}</span>\n          </div>\n        </div>\n      </ion-button>\n      <p class=\"d-flex flex-column billet-code-p-tag\">\n        <span class=\"font-weight-bold\">\n          {{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.BILLET_CODE' | wlpTranslate}}\n        </span>\n        <span id=\"copyTarget\">\n          {{billetCode}}\n        </span>\n      </p>\n    </div>\n  </div>\n\n  <div class=\"group-buttons\">\n    <div class=\"container content-below\">\n      <ion-row class=\"ion-justify-content-center\">\n        <ion-col size-sm=\"12\" size-md=\"10\" class=\"ion-padding-vertical\">\n          <ui-c-button *ngIf=\"hasPrintButton\" class=\"btn-green\" expand=\"block\" (continue)=\"printBillet()\">\n            {{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.BUTTON.PRINT' | wlpTranslate}}\n          </ui-c-button>\n          <div class=\"mt-1\" *ngIf=\"hasShareButton\">\n            <ui-c-button class=\"blue-button\" expand=\"block\" (continue)=\"shareBillet()\">\n              {{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.BUTTON.SHARE' | wlpTranslate}}\n            </ui-c-button>\n          </div>\n          <div class=\"mt-1\" *ngIf=\"hasCancelButton\">\n            <ui-c-button class=\"cancel-button\" expand=\"block\" (continue)=\"dismissEvent()\">\n              {{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.BUTTON.CANCEL' | wlpTranslate}}\n            </ui-c-button>\n          </div>\n        </ion-col>\n      </ion-row>\n    </div>\n  </div>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [ToastController,
        ClipboardService])
], UiCBilletReviewComponent);

let UiCBilletReviewModule = class UiCBilletReviewModule {
};
UiCBilletReviewModule = __decorate([
    NgModule({
        declarations: [
            UiCBilletReviewComponent
        ],
        imports: [
            CommonModule,
            IonicModule,
            UiCButtonModule,
            UiBsTranslateModule,
            ClipboardModule
        ],
        providers: [
            ClipboardService
        ],
        exports: [
            UiCBilletReviewComponent
        ]
    })
], UiCBilletReviewModule);

export { UiCBilletReviewComponent, UiCBilletReviewModule };
//# sourceMappingURL=wlp-ui-c-billet-review.js.map
